
<template>
  <div>
    <el-form
      ref="receiptForm"
      :model="params"
      :rules="rules"
      size="small"
    >
      <!--客户-->
      <el-form-item :label="$t('GlobalSetObj.client')" prop="customerId">
        <CustomerSelectCmp style="width: 100%" :is-all="false" @change=" val => params.customerId = val" />
      </el-form-item>
      <!-- 对账单类型-->
      <el-form-item :label="$t('receivablePayable.statementType')" prop="statementType">
        <el-select
          v-model="params.statementType"
          :placeholder="$t('operationCenter.PleaseSelect')"
          clearable
          size="small"
          filterable
          style="width: 100%;"
        >
          <el-option
            v-for="item in EXPRESS_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- 账单日期-->
      <el-form-item :label="$t('receivablePayable.BillingDate')" prop="time">
        <el-date-picker
          v-model="params.time"
          type="daterange"
          style="width: 100%"
          :start-placeholder="$t('operationCenter.startDate')"
          :end-placeholder="$t('operationCenter.endDate')"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
    </el-form>
    <div class="flex-c">
      <el-button
        icon="el-icon-download"
        size="small"
        type="primary"
        style="margin: 0 10px 10px 0"
        @click="operationBtn"
      >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
      <upload-excel
        :on-success="importLogistics"
        :but-name="$t('receivablePayable.ImportFile')"
      />
    </div>
  </div>
</template>

<script>
import { apiImportGenerateReceipt } from '@/api/finance/receivables';
import { checkSameMonth } from '@/views/finance/utils';
import { goFileUploadManagement } from '@/utils/goExportList';
import { EXPRESS_TYPE } from '@/views/finance/receivableManagementSite/aRGenerationNew/utils';

const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';
import { cloneDeep } from 'lodash-es';

export default {
  components: {
    uploadExcel: () => import('@/components/UploadExcel/index.vue'),
    CustomerSelectCmp: () => import('@/components/CustomerSelectCmp/CustomerSelectCmp.vue')
  },
  data() {
    return {
      EXPRESS_TYPE,
      params: {
        customerId: '',
        statementType: '',
        time: ''
      },
      rules: {
        customerId: [
          { required: true, message: this.$t('operationCenter.PleaseSelect'), trigger: 'change' }
        ],
        statementType: [
          { required: true, message: this.$t('operationCenter.PleaseSelect'), trigger: 'change' }
        ],
        time: [
          { required: true, message: this.$t('operationCenter.PleaseSelect'), trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    operationBtn() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: '业务单号',
            key: 'waybillNumber',
            width: 80
          },
          {
            header: '订单号',
            key: 'orderNumber',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'número do negócio';
        Sheet1.getCell('B2').value = 'Número do pedido';
        Sheet1.mergeCells('A3:B3');
        Sheet1.getCell('A3').value = `
          1、每次仅导入 150000 条 /Importar apenas 150000 itens de cada vez
          2、必填 /Obrigatório
          3、不可更改此模板 /Esse modelo não pode ser alterado
        `;
        Sheet1.getRow(3).height = 60;
        Sheet1.getRow(3).getCell(1).style = {
          font: {
            color: { argb: 'ff0000' }
          },
          alignment: {
            vertical: 'bottom', // 垂直居中
            horizontal: 'left', // 水平左对齐
            wrapText: true // 自动换行
          }
        };
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('receivablePayable.importGenerateReceipt') + that.$t('receivablePayable.template') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },
    importLogistics(arr) {
      const excelData = arr[0].results.slice(2);
      console.log(excelData, '导入数据');
      const headObj = {
        '业务单号': 'waybillNumber',
        '订单号': 'orderNumber'
      };
      const dataList = [];
      this.$refs.receiptForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const params = cloneDeep(this.params);
        const time = params.time;
        // 时间校验
        const flag = checkSameMonth(time);

        // 检查是否同一年月
        if (!flag) {
          this.$message.warning(this.$t('receivablePayable.dateRangeSameMonthValidation'));
          return;
        }
        // 生成时间处理
        params.startTime = time[0];
        params.endTime = time[1];
        delete params.time;

        for (const item of excelData) {
          const data = {};
          try {
            for (const key of Object.keys(item)) {
              if (headObj[key]) {
                data[headObj[key]] = item[key] + '';
              }
              // data[headObj[key] || key] = item[key] || '';
            }
          } catch (error) {
            console.error(error);
            this.$message.error(this.$t('basicData.dataProcessingError'));
            return;
          }
          dataList.push(data);
        }
        console.log(dataList);
        if (!dataList.length) {
          return this.$message.error(this.$t('GlobalSetObj.required'));
        }
        if (dataList.length > 150000) {
          return this.$message.error(this.$t('receivablePayable.singleImportLimit', { size: 150000 }));
        }
        const flags = dataList.every(item => {
          return item.waybillNumber && item.orderNumber;
        });
        console.log(flags);
        if (!flags) {
          return this.$message.error(this.$t('GlobalSetObj.required'));
        }
        params.list = dataList;
        apiImportGenerateReceipt(params).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
            goFileUploadManagement(this).then(flag => {
              if (flag) {
                this.$refs.receiptForm.resetFields();
                this.$emit('close');
              }
            });
          }
        }).catch(error => {
          console.error(error);
        });
      });
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  justify-content: end;
}
</style>
